import { ReactSVG } from "react-svg";

interface IconProps {
  src: string;
  height?: number;
  width?: number;
  alt?: string;
  extraClassName?: string;
  ariaLabel?: string;
  ariaHidden?: boolean;
}

export const Icon = ({
  src,
  height = 27,
  width = 27,
  extraClassName = "icon",
  alt = "Icon",
  ariaLabel = "Icon",
  ariaHidden = false,
}: IconProps) => {
  return (
    <ReactSVG
      className={extraClassName}
      src={src}
      wrapper={"svg"}
      width={height}
      height={width}
      aria-hidden={ariaHidden}
      beforeInjection={(svg) => {
        svg.setAttribute("alt", alt);
        svg.setAttribute("aria-label", ariaLabel);
      }}
    />
  );
};
